var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myfinbiz-page"},[(!_vm.showSurvey)?_c('MyfinbizIntro',{on:{"start-survey":_vm.startSurvey}}):_c('MyfinbizChatSurvey')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }